/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Testimonial_2_RoleInputs */

const en_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const es_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA`)
};

const de_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const zh_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA 职业教练`)
};

const ar_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محترف PGA`)
};

const fr_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionnel PGA`)
};

const vi_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyên gia PGA`)
};

const sw_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mtaalamu wa PGA`)
};

const th_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มืออาชีพ PGA`)
};

const bs_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA profesionalac`)
};

const ja_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGAプロ`)
};

const ko_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA 전문가`)
};

const pt_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profissional PGA`)
};

const it_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const sv_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professionell`)
};

const nl_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const da_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const nb_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Profesjonell`)
};

const fi_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const pl_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const ru_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профессионал PGA`)
};

const tr_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Profesyonel`)
};

const hi_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA प्रोफेशनल`)
};

const id_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA`)
};

const ms_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA`)
};

const cs_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesionál PGA`)
};

const el_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA επαγγελματίας`)
};

const he_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const af_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

const hu_home_testimonial_2_role = /** @type {(inputs: Home_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional`)
};

/**
* | output |
* | --- |
* | "PGA Professional" |
*
* @param {Home_Testimonial_2_RoleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_testimonial_2_role = /** @type {((inputs?: Home_Testimonial_2_RoleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Testimonial_2_RoleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_testimonial_2_role(inputs)
	if (locale === "de") return de_home_testimonial_2_role(inputs)
	if (locale === "zh") return zh_home_testimonial_2_role(inputs)
	if (locale === "ar") return ar_home_testimonial_2_role(inputs)
	if (locale === "fr") return fr_home_testimonial_2_role(inputs)
	if (locale === "vi") return vi_home_testimonial_2_role(inputs)
	if (locale === "sw") return sw_home_testimonial_2_role(inputs)
	if (locale === "th") return th_home_testimonial_2_role(inputs)
	if (locale === "bs") return bs_home_testimonial_2_role(inputs)
	if (locale === "ja") return ja_home_testimonial_2_role(inputs)
	if (locale === "ko") return ko_home_testimonial_2_role(inputs)
	if (locale === "pt") return pt_home_testimonial_2_role(inputs)
	if (locale === "it") return it_home_testimonial_2_role(inputs)
	if (locale === "sv") return sv_home_testimonial_2_role(inputs)
	if (locale === "nl") return nl_home_testimonial_2_role(inputs)
	if (locale === "da") return da_home_testimonial_2_role(inputs)
	if (locale === "nb") return nb_home_testimonial_2_role(inputs)
	if (locale === "fi") return fi_home_testimonial_2_role(inputs)
	if (locale === "pl") return pl_home_testimonial_2_role(inputs)
	if (locale === "ru") return ru_home_testimonial_2_role(inputs)
	if (locale === "tr") return tr_home_testimonial_2_role(inputs)
	if (locale === "hi") return hi_home_testimonial_2_role(inputs)
	if (locale === "id") return id_home_testimonial_2_role(inputs)
	if (locale === "ms") return ms_home_testimonial_2_role(inputs)
	if (locale === "cs") return cs_home_testimonial_2_role(inputs)
	if (locale === "el") return el_home_testimonial_2_role(inputs)
	if (locale === "he") return he_home_testimonial_2_role(inputs)
	if (locale === "af") return af_home_testimonial_2_role(inputs)
	if (locale === "hu") return hu_home_testimonial_2_role(inputs)
	return en_home_testimonial_2_role(inputs)
});